class IconList {
  constructor(el) {
    this.el = el;
    this.buttonShowAll = this.el.querySelector('.show-all');
    this.list = this.el.querySelector('.icon-list__list');
    this.show = this.show.bind(this);
    this.init();
  }

  init() {
    if (this.buttonShowAll)
      this.buttonShowAll.addEventListener('click', this.show);
  }

  show() {
    this.list.classList.remove('icon-list__list--closed');
    this.buttonShowAll.classList.add('hidden');
  }
}

export default IconList;
